<div class="notification-container">
    <div class="notification-list">
        <div class="list-header">
            <h2>Notifications</h2>
        </div>

        <div class="filter-section">
            <div class="filter-group">
                <label for="readStatus">Status</label>
                <p-dropdown 
                    id="readStatus"
                    [formControl]="readStatusFilter"
                    [options]="readStatusOptions" 
                    optionLabel="label" 
                    optionValue="value"
                    [showClear]="false">
                </p-dropdown>
            </div>

            <div class="filter-group">
                <label for="titleSearch">Title</label>
                <input 
                    id="titleSearch"
                    pInputText 
                    type="text" 
                    [formControl]="titleFilter"
                    placeholder="Search title...">
            </div>

            <div class="filter-group">
                <label for="startDate">From Date</label>
                <p-calendar 
                    id="startDate"
                    [formControl]="startDateFilter"
                    dateFormat="mm/dd/yy"
                    [showIcon]="true">
                </p-calendar>
            </div>

            <div class="filter-group">
                <label for="endDate">To Date</label>
                <p-calendar 
                    id="endDate"
                    [formControl]="endDateFilter"
                    dateFormat="mm/dd/yy"
                    [showIcon]="true">
                </p-calendar>
            </div>

            <p-button 
                label="Clear Filters" 
                (onClick)="clearFilters()"
                [text]="true"
                class="clear-button">
            </p-button>
        </div>

        <p-table
            class="small-text-table"
            [value]="(filteredMessages$ | async) || []"
            [rows]="10"
            [responsive]="true">
            <ng-template pTemplate="body" let-message let-index="rowIndex">
                <tr 
                    (click)="selectMessage(message)"
                    [class.selected]="(selectedMessage$ | async)?.id === message.id"
                    [class.unread]="!message.read"
                    class="clickable-row">
                    <td>{{ message.title }}</td>
                    <td>{{ message.messageTime | date:'MM/dd/yy HH:mm:ss z' }}</td>
                    <td>{{ message.read ? 'Read' : 'Unread' }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    
    <div class="message-detail" *ngIf="(selectedMessage$ | async) as selectedMessage">
        <div class="detail-header">
            <h3>{{ selectedMessage.title }}</h3>
            <p-button 
                [text]="true" 
                icon="pi pi-times" 
                (click)="clearSelection()"
                [rounded]="true">
            </p-button>
        </div>
        <div class="detail-content">
            <p>{{ selectedMessage.message }}</p>
        </div>
    </div>

    <div class="message-detail empty" *ngIf="!(selectedMessage$ | async)">
        <p class="placeholder-text">Select a message to view details</p>
    </div>
</div>